var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"close animated",class:{fadeInLeft:_vm.projectOpened,'hide-close':!_vm.projectOpened},on:{"click":_vm.close}},[_c('i',{staticClass:"iconfont icon-guanbi"})])}
var staticRenderFns = []

export { render, staticRenderFns }